// Thin wrappers around the RTK Query hooks — component code should prefer these
// so it stays decoupled from the raw endpoint naming.

import { useGetCampaignQuery, useGetCampaignStatsQuery } from '../campaignsApi';

export const useCampaign = (campaignId, options = {}) =>
  useGetCampaignQuery(campaignId, {
    skip: !campaignId,
    ...options,
    selectFromResult: ({ data, isLoading, isFetching, isError }) => ({
      campaign: data ?? null,
      isLoading,
      isFetching,
      isError,
    }),
  });

export const useCampaignStats = (dateRange, options = {}) =>
  useGetCampaignStatsQuery(dateRange, {
    ...options,
    selectFromResult: ({ data, isLoading, isFetching, isError }) => ({
      stats: data ?? {
        activeCampaigns: 0,
        activeDelta: 0,
        totalSent: 0,
        sentDelta: 0,
        averageOpenRate: 0,
        openRateDelta: 0,
        totalRevenue: 0,
        revenueDelta: 0,
      },
      isLoading,
      isFetching,
      isError,
    }),
  });
